import React from 'react';
import TR from '../../Trans';
import Button from '@mui/material/Button';
import BDialog from './BDialog';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Link from '@mui/material/Link';
import { AppleStoreKitExternalLinkAccount } from '@kokotree-inc/capacitor-plugin-apple-storekit-external-link-account';
import muvikaAttrs from './../../attrs'

function IosExternalLinkDialog(props) {

  const openDialog = () => { 
    AppleStoreKitExternalLinkAccount.canOpen()
    .then(results => {
      if(results.value){
        AppleStoreKitExternalLinkAccount.open();
      }
    });
  }

  return (
    <BDialog disableRestoreFocus open={props.open} onClose={props.onClose}>
      <DialogContent>
        {props.message} <Link className="muvika-link-und" onClick={openDialog} variant="body2">{muvikaAttrs.iosExternalLinkUrlTitle}</Link>
        {/* {props.message} {muvikaAttrs.iosExternalLinkUrl} */}
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={6} justifyContent="center">
          <Button color="secondary" onClick={props.onClose}>{TR.cm_cancel}</Button>
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default IosExternalLinkDialog;